<div>
    <div class="modal-header">
        <div class="d-inline-flex align-items-center">
            <mat-icon matSuffix svgIcon="total-calendar"></mat-icon>
            <h3>{{
                isEditMode ? (('pages.createInspectionDialog.edit_title' | translate) +
                (draftInspection?.inspectionDate | localeDate:'mediumDate'))
                : ('pages.createInspectionDialog.title' | translate)
                }}</h3>
        </div>
        <button mat-icon-button class="red-color" (click)="onCancel()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content class="modal-content">
        <form [formGroup]="form">
            <mat-label>
                <span class="red-color">* </span>{{ 'pages.createInspectionDialog.inspection_date' | translate }}
            </mat-label>
            <mat-form-field appearance="outline" class="w-100">
                <input matInput [matDatepicker]="picker" formControlName="inspectionDate" [max]="todayDate"/>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>


            <mat-label>{{ 'pages.createInspectionDialog.notes_description' | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-100">
                <textarea matInput formControlName="notes"></textarea>
            </mat-form-field>
        </form>
    </div>

    <div mat-dialog-actions class="modal-footer">
        <div>
            <span class="red-color">*</span> {{ 'pages.user_modal.mandatory' | translate }}
        </div>
        <div>
            <button mat-button (click)="onCancel()">{{ 'general.actions.cancel' | translate }}</button>
            <button mat-raised-button color="primary" (click)="onSave()"
                    [disabled]="form.invalid">{{ 'general.actions.continue' | translate }}
            </button>
        </div>
    </div>
</div>
